import { useEffect, useState } from "react";
import { useContract } from "./useContract";
import { transformArray } from "~/pages/ListOfDocuments/Modals/helper";

export interface FilterIProps {
  dealers?: { value: string; label: string }[];
  dateFrom?: string | Date;
  dateTo?: string | Date;
  id?: string;
}
interface useContractListIProps {
  filter?: FilterIProps;
  type: string;
  page: string;
  count: string;
}

export const useContractList = ({
  filter,
  type,
  page,
  count,
}: useContractListIProps) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getContractList, getAdditionalList } = useContract();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const params = new URLSearchParams();
      if (filter?.dealers?.length) {
        filter.dealers.forEach((dealer) => {
          params.append("dealerSearch[ids][]", dealer.value);
        });
      }
      if (filter?.id) {
        params.append("contractNumber", filter.id);
      }
      if (filter.dateFrom && filter.dateTo) {
        params.append("dateFrom", filter.dateFrom.toString());
        params.append("dateTo", filter.dateTo.toString());
      }

      params.append("status", "active");
      params.append("page", page);
      params.append("count", count);
      params.append("contractType", type);
      let res;
      if (type === "main") {
        res = await getContractList(params.toString());
      } else {
        res = await getAdditionalList(params.toString());
      }

      let formatData = [];
      if (res.data?.dealers) {
        formatData = transformArray({
          arr: res.data.dealers,
          arg: "contracts",
          filter,
        });
      }
      setData({ formatData, totalCount: res.data.totalCount });
    } catch (error) {
      setError("Ошибка загрузки договоров.");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [filter, page, count, type]);

  const refetch = () => {
    fetchData();
  };

  return { data, isLoading, error, refetch };
};
